import {useParams} from "react-router";
import {Template} from "../../../../components/template/template";
import Button from "../../../../components/button/button";
import {FaInfoCircle, FaPlus} from "react-icons/fa";
import {Card} from "../../../../components/card/card";
import InputForm from "../../../../components/input/input-form";
import SelectComponent from "../../../../components/select/select-component";
import {useAlarmQuestionFormQuery} from "../components/use-alarm-form-query";
import {navigateHook} from "../../../../hooks/use-navigate";
import {useEffect, useState} from "react";
import ProjectUtils from "../../../../utils/project-utils";
import Swal from "sweetalert2";
import InputCheckbox from "../../../../components/input/input-checkbox";
import alarmQuestionService from "../../../../services/web/alarm-question-service";
import projectUtils from "../../../../utils/project-utils.js";

const AlarmQuestionForm = ({}) => {
    const navigate = navigateHook();
    const params = useParams();

    const rawId = params?.id;
    const [currentId, setCurrentId] = useState(rawId && rawId !== "null" ? Number(rawId) : null);
    const isSystemQuestion = currentId === 1;
    const { initialQuestion, isAnyLoading, refetch } = useAlarmQuestionFormQuery(currentId);
    const loader = isAnyLoading;

    const [isSaving, setIsSaving] = useState(false);
    const [question, setQuestion] = useState("");
    const [typeAnswer, setTypeAnswer] = useState("");
    const [required, setRequired] = useState(false);

    useEffect(() => {
        if(!initialQuestion) return;

        setQuestion(initialQuestion.question ?? "");
        setTypeAnswer(initialQuestion.type_answer ?? "");
        setRequired(!!initialQuestion.required);
    }, [initialQuestion]);

    const validate = () => {
        if(!question?.trim()) return 'O campo "Descrição" é obrigatório.';
        if(!typeAnswer) return 'O campo "Tipo de resposta" é obrigatório.';

        return null;
    }
    
    const handleSave = () => {
        setIsSaving(true);

        const err = validate();
        if(err) {ProjectUtils.swalErrorMessage('', err, 'Ok'); setIsSaving(false); return;};

        const payload = {
            question,
            type_answer: typeAnswer,
        };

        if(required) {
            payload.required = true;
        }

        const request = currentId
            ? alarmQuestionService.update(currentId, payload)
            : alarmQuestionService.create(payload);

        request.then((response) => {
            const data = response.data?.data ?? response.data;
            const newId = data?.id ?? currentId;

            setCurrentId(newId);

            projectUtils.success(!currentId);

            if(currentId) {
                refetch?.();
                return;
            }

            const urlDev = `/alarm-question/form/${newId}`;
            navigate(urlDev);
        })
        .catch((error) => {
            console.error(error);
            let message = "Não foi possível salvar.";

            if(error.response?.data) {
                message = error.response.data.message || error.response.data.error || message;
            }

            ProjectUtils.swalErrorMessage("", message, "Ok");
        })
        .finally(() => {
            setIsSaving(false);
        });
    };

    const handleDelete = () => {
        if(!currentId) return;

        Swal.fire({
            title: "Excluir",
            text: `Excluir a pergunta de alarme "${question}"?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#063A6C",
            confirmButtonText: "Sim",
            cancelButtonColor: "#c10007",
            cancelButtonText: "Não",
            reverseButtons: true,
        }).then((result) => {
            if(result.isConfirmed) {
                return alarmQuestionService
                    .remove(currentId)
                    .then(() => {
                        projectUtils.success(true, "Excluído com sucesso");
                        const urlDev = `/alarm-question`;
                        navigate(urlDev);
                    })
                    .catch(() => {
                        ProjectUtils.swalErrorMessage("", "Erro ao excluir", "Ok");
                    })
            }
        });
    }

    const resetForm = () => {
        setQuestion("");
        setTypeAnswer("");
        setRequired(false);
    }

    const newQuestion = () => {
        setCurrentId(null);
        resetForm();

        const urlDev = `/alarm-question/form`;
        navigate(urlDev);
    }

    const typeAnswerOptions = [
        { value: "SELECTION", label: "Resposta Sim / Não" },
        { value: "TEXT", label: "Resposta em texto" },
    ];

    return(
        <Template isLoading={loader || isSaving}>
            <Template.Header>
                <Template.Title>Pergunta</Template.Title>
                {currentId && (
                    <Button
                        onClick={newQuestion}
                        target="primary-outline"
                    >
                        <FaPlus /> Adicionar pergunta
                    </Button>
                )}
            </Template.Header>
            <Template.Body className="space-y-2">
                <Card>
                    <Card.Body className="space-y-4">
                        <div className="flex">
                            <InputForm
                                label="Descrição *"
                                type="text"
                                classNameWrapper="flex-1"
                                value={question}
                                onChange={(e) => setQuestion(e.target.value)}
                                disabled={isSystemQuestion}
                            />
                        </div>
                        <div className="flex">
                            <SelectComponent
                                label="Tipo de resposta *"
                                options={typeAnswerOptions}
                                type="select"
                                classNameWrapper="flex-1"
                                value={typeAnswerOptions.find(o => o.value === String(typeAnswer)) ?? null}
                                onChange={(opt) => setTypeAnswer(opt?.value ?? "")}
                                isDisabled={isSystemQuestion}
                            />
                        </div>
                        <div className="flex pl-1">
                            <InputCheckbox
                                id={'required'}
                                label="Obrigatória"
                                checked={required}
                                onChange={(e) => setRequired(e.target.checked)}
                                disabled={isSystemQuestion}
                            />
                        </div>
                    </Card.Body>
                    {isSystemQuestion && (
                        <Card className="!rounded-t-none">
                        <Card.Body>
                            <span className="inline-flex items-center gap-2 bg-[#a7d4ff] text-[#1c657d] rounded px-3 py-2 text-base">
                                <FaInfoCircle />
                                Essa é uma pergunta padrão de sistema e não pode ser editada ou excluída
                            </span>
                        </Card.Body>
                    </Card>
                    )}
                </Card>
                {!isSystemQuestion && (
                    <Card>
                        <Card.Body className="flex gap-2 justify-end">
                            {!isSystemQuestion && currentId && (
                                <Button onClick={handleDelete} target="danger" actionFeedbackType='delete'>Excluir</Button>
                            )}
                            <Button onClick={handleSave} target="primary" disabled={isSaving || loader} actionFeedbackType='save'> Salvar</Button>
                        </Card.Body>
                    </Card>
                )}
            </Template.Body>
        </Template>
    )
}

export default AlarmQuestionForm;